export default "__VITE_ASSET__cf25425b__"